const renderViTriMat = id => {
  if (id == 0) return "Mắt trái";
  if (id == 1) return "Mắt phải";
  if (id == 2) return "Cả 2 mắt";
  else return "";
};
const checkEmptyObjVitalSigns = data => {
  let isEmpty = true;
  const listKey1 = ["BMI", "Comment", "Height", "Weight"];
  const listKey2 = ["BloodPressure", "Pulse", "RR", "Sp02", "Temperature"];
  if (!data) {
    isEmpty = true;
    return isEmpty;
  }
  if (Object.keys(data).length === 0) {
    isEmpty = true;
  } else {
    for (var prop in data) {
      if (listKey1.includes(prop) && data[prop]) {
        isEmpty = false;
      }
      if (
        listKey2.includes(prop) &&
        data[prop]?.Result?.findIndex(result => result?.value) != -1 &&
        data[prop]?.Result?.findIndex(result => result?.value) != undefined
      ) {
        isEmpty = false;
      }
    }
  }
  return isEmpty;
};
export {renderViTriMat, checkEmptyObjVitalSigns};
